import React from 'react';

import facebook from '../imagenes/facebook.svg';
import whatsapp from '../imagenes/whatsapp.svg';
import gmail from '../imagenes/gmail.svg';
import instagram from '../imagenes/instagram.svg';

const Footer = () => {
  return (
    <div className="footer">
      <div className="TitFoot">CARNES A LA PARRILLA</div>

      <div className="SubTitFoot">
        EVENTOS / RESERVAS / DOMICILIOS
        <br />
        SIGUENOS EN
      </div>

      <div className="DivRedes">

        <a
          className="LinkFace"
          href="https://m.facebook.com/tablitasycarnes"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img className="link" src={facebook} alt="Facebook" />
        </a>

        <a
          className="LinkFace"
          href="whatsapp://send?phone=+573143843939&text=Buenas tardes, me gustaria ordenar."
          target="_blank"
          rel="noopener noreferrer"
        >
          <img className="link" src={whatsapp} alt="WhatsApp" />
        </a>

        <a
          className="LinkFace"
          href="mailto:tablitasycarnes@gmail.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img className="link" src={gmail} alt="Gmail" />
        </a>

        <a
          className="LinkFace"
          href="https://www.instagram.com/tablitasycarnes/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img className="link" src={instagram} alt="Instagram" />
        </a>

      </div>
    </div>
  );
};

export default Footer;